// extracted by mini-css-extract-plugin
export default {"container":"_3SJxeF-XM9","icon":"_3h4eC6HhQy","title-section-container":"_1Wr5PLXF1f","titleSectionContainer":"_1Wr5PLXF1f","title-section":"rwQFu81Rbw","titleSection":"rwQFu81Rbw","title":"_3p_37PX3DQ","id":"_3MUyRAmn39","id-prefix":"_1reH8agWs5","idPrefix":"_1reH8agWs5"};
    if(module.hot) {
      // 1633091769939
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  